import React, { Fragment } from 'react';
import { Button, Col, Form, message, notification, Row } from 'antd';
import SupplierInformation from './components/SupplierInformation';
import ProductInformation from './components/ProductInformation';
import * as CommonService from '../../../services/CommonService';
import { PURCHASE_ORDER } from '../../../services/endpoint';
import { useHistory } from 'react-router-dom';

const PurchaseOrderCreate = (props) => {

	const history = useHistory();

	const [mapImei, setMapImei] = React.useState({});
	const [selectedProduct, setSelectedProduct] = React.useState([]);
	const [supplier, setSupplier] = React.useState(null);

	const handleSubmit = (e) => {
		e.preventDefault();
		props.form.validateFields((err, values) => {
			if (!err) {
				let errorMsg = null;
				if (!supplier) {
					errorMsg = 'Vui lòng chọn nhà cung cấp';
				}
				const orderProductRequests = selectedProduct.map((el, idx) => {
					return {
						productId: el.id,
						quantity: el.isNormal ? el.quantity : mapImei[idx]?.length || 0,
						price: el.importPrice,
						discount: el.discount || 0,
						imei: mapImei[idx] || []
					};
				});
				const body = {
					supplierId: supplier?.id || null,
					deliveryDate: values.deliveryDate,
					note: values.note,
					discount: values.discount || 0,
					orderProductRequests
				};
				if (orderProductRequests.length === 0) {
					errorMsg = 'Vui lòng chọn sản phẩm';
				} else if (orderProductRequests.some(el => el.quantity === 0)) {
					errorMsg = 'Số lượng nhập không thể = 0';
				}
				if (errorMsg) {
					notification.error({ title: 'Lỗi', message: errorMsg, duration: 3 });
					return;
				}
				window.setLoading(true);
				CommonService.create(PURCHASE_ORDER, body).then(res => {
					if (res) {
						message.success('Tạo đơn nhập hàng thành công');
						history.push('/purchase-order');
					}
				}).catch(err => {
					if (err?.data?.message === 'IMEI_ALREADY_EXISTS') {
						mapImei.existed = err?.data?.data || [];
						message.error(`IMEI đã tồn tại trên hệ thống`);
					} else {
						message.error(err?.data?.message);
					}
				}).finally(() => window.setLoading(false));
			}
		});
	};

	return (
		<Fragment>
			<Form layout={'vertical'}>
				<Row>
					<Col>
						<SupplierInformation form={props.form}
																 supplier={supplier}
																 setSupplier={setSupplier}
						/>
					</Col>
					<Col>
						<ProductInformation form={props.form}
																mapImei={mapImei}
																setMapImei={setMapImei}
																selectedProduct={selectedProduct}
																setSelectedProduct={setSelectedProduct}
						/>
					</Col>
				</Row>
				<Col style={{ textAlign: 'right', marginTop: 10 }}>
					<Button style={{ marginRight: '5px' }} onClick={() => history.push('/purchase-order')}>Thoát</Button>
					<Button type={'primary'} onClick={handleSubmit}>Tạo đơn hàng</Button>
				</Col>
			</Form>
		</Fragment>
	);
};
export default Form.create({ name: 'PurchaseOrderCreate' })(PurchaseOrderCreate);
